import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapState } from "vuex";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import ClientActivityAnchor from "@Shared/components/client-activity/client-activity-anchor.vue";
import ClientActivityLoader from "./client-activity-loader.vue";
import { CURRENT_USER_USERNAME } from "@Client/@Modules/main/store/account/account-getters";
import { GET_CLIENT_ACTIVITY } from "../store/dashboard-getters";
import { LOAD_CLIENT_ACTIVITY } from "../store/dashboard-actions";
import { defineComponent } from "@vue/composition-api";
import { isEmpty } from "lodash";
export default defineComponent({
  name: "ClientsActivity",
  components: {
    ProfileAvatar,
    ClientActivityAnchor,
    ClientActivityLoader
  },
  data() {
    return {
      loading: true,
      loadingClients: false,
      offset: 0,
      limit: 20,
      shouldFetchMore: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapGetters("DashboardStore", [GET_CLIENT_ACTIVITY])), mapState("AccountStore", {
    applicationId(state) {
      return state.selectedApplicationId;
    }
  })), {}, {
    recentActivities() {
      return this.GET_CLIENT_ACTIVITY;
    },
    titleText() {
      return this.$t("dashboard.clientActivities.cardTitle");
    },
    currentUsername() {
      return this.CURRENT_USER_USERNAME;
    }
  }),
  mounted() {
    this.loadActivities();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DashboardStore", [LOAD_CLIENT_ACTIVITY])), {}, {
    buttonText(type) {
      const map = {
        "new-client-signup": "",
        "document-uploaded": this.$tc("dashboard.viewDocument", 1),
        "requested-documents": this.$tc("dashboard.viewDocument", 2),
        "marked-document-complete": this.$tc("dashboard.viewDocument", 1),
        "marked-document-outstanding": this.$tc("dashboard.viewDocument", 1),
        "application-changed": this.$t("dashboard.clientActivities.seeApplication"),
        "application-submitted": this.$t("dashboard.clientActivities.seeApplication"),
        "comment-added-to-document": this.$tc("dashboard.viewDocument", 2),
        "reminder-added": this.$t("dashboard.clientActivities.viewNote")
      };
      return map[type];
    },
    async loadActivities() {
      if (!this.shouldFetchMore || this.loadingClients) return;
      this.loadingClients = true;
      this.shouldFetchMore = await this.LOAD_CLIENT_ACTIVITY({
        applicationId: this.applicationId,
        offset: this.offset,
        limit: this.limit
      });
      this.offset += this.limit;
      this.loading = false;
      this.loadingClients = false;
    },
    uploadedByClient(activity) {
      return isEmpty(activity.metadata.coApplicant);
    },
    onScrollBottom({
      target: {
        scrollTop,
        clientHeight,
        scrollHeight
      }
    }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.loadActivities();
      }
    },
    isEmpty(value) {
      return isEmpty(value);
    }
  })
});